import request from '../../utils/request';

const AuthentificationService = {
  verifyProfile: () => {
    return request('/user/profile', {
      method: 'POST',
    });
  },

  login: (
    /** @type {{ name: any; password: any; }} */ formData: {
      email: any;
      password: any;
    }
  ) => {
    return request('/user/login', {
      method: 'POST',
      body: JSON.stringify({
        email: formData.email,
        password: formData.password,
      }),
    });
  },

  logout: () => {
    return request('/user/logout', {
      method: 'POST',
    });
  },
};

export default AuthentificationService;
